import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

function SplashScreen({ onFinish }) {
  const [saindo, setSaindo] = useState(false);
  const [pct, setPct] = useState(0);
  const finalizadoRef = React.useRef(false);

  const finalizar = React.useCallback(() => {
    if (finalizadoRef.current) return;
    finalizadoRef.current = true;
    setPct(100);
    setSaindo(true);
    setTimeout(onFinish, 360);
  }, [onFinish]);

  useEffect(() => {
    const progressos = [
      [0,    0],
      [400,  18],
      [1100, 42],
      [2000, 66],
      [3000, 86],
      [3800, 100],
    ];
    const timers = progressos.map(([t, v]) =>
      setTimeout(() => setPct(v), t)
    );
    const t1 = setTimeout(finalizar, 4000);
    return () => { [...timers, t1].forEach(clearTimeout); };
  }, [finalizar]);

  return (
    <div className={`sp-container ${saindo ? 'sp-saindo' : ''}`}>

      <div className="sp-grid" />
      <div className="sp-orb sp-orb1" />
      <div className="sp-orb sp-orb2" />
      <div className="sp-orb sp-orb3" />
      <div className="sp-hline" />
      <div className="sp-corner sp-c-tl" />
      <div className="sp-corner sp-c-tr" />
      <div className="sp-corner sp-c-bl" />
      <div className="sp-corner sp-c-br" />

      <div className="sp-center">
        <div className="sp-hex-wrap">
          <div className="sp-hex-border" />
          <div className="sp-hex">
            <span className="sp-hex-letter">E</span>
          </div>
          <div className="sp-scan" />
        </div>

        <div className="sp-name">Evalon</div>

        <div className="sp-event">
          <span className="sp-event-kicker">Plataforma oficial de avaliação</span>
          <strong>46º Congresso Brasileiro de Angiologia<br />e de Cirurgia Vascular</strong>
          <span>2026 · Salvador · Bahia</span>
        </div>

        <div className="sp-deco-lines">
          <div className="sp-deco-main" />
          <div className="sp-deco-thin" />
        </div>

        <div className="sp-powered">
          <span className="sp-pw-txt">powered by</span>
          <span className="sp-dot" />
          <span className="sp-nv-txt">NimVexx</span>
        </div>

        <div className="sp-mh-txt">Mahfouz Tech</div>

        <div className="sp-tagline">
          <span className="sp-tg-txt">
            Avaliação inteligente para eventos científicos
          </span>
        </div>
      </div>

      <div className="sp-prog-wrap">
        <div className="sp-prog-track">
          <div className="sp-prog-fill" style={{ width: `${pct}%` }} />
        </div>
        <div className="sp-prog-label">Preparando o ambiente de avaliação</div>
      </div>

      <button className="sp-skip" type="button" onClick={finalizar}>Pular introdução</button>
    </div>
  );
}

export default SplashScreen;
